import AnimalProfileModal from "components/AnimalProfile/AnimalProfileModal";
import Button from "components/UI/Button";
import Modal from "components/UI/Modal";
import React from "react";
import { FormProvider, UseFormReturn } from "react-hook-form";
import { getProfileTitle, isQldRegion } from "utils/petFormHelpers";
import SupportDocument from "./SupportDocument";

type Props = {
  open: boolean;
  onClose: () => void;
  modalForm: UseFormReturn<any>;
  selectedType: string;
  selectedIdx: number;
  selectedPetData: any;
  selectedPetDocuments: any[];
  formTemplate: any;
  renderAnimalCards: (type: string, idx: number) => React.ReactNode;
  deviceType: string;
};

const ProfileModal: React.FC<Props> = ({ open, onClose, modalForm, selectedType, selectedIdx, selectedPetData, selectedPetDocuments, formTemplate, renderAnimalCards, deviceType }) => {
  if (!open || !selectedPetData) return null;
  const profileTitle = getProfileTitle(selectedType, selectedIdx);
  return (
    <Modal width="960" onClose={onClose}>
      <FormProvider {...modalForm}>
        <Button className="modal_close_btn d-block d-md-none position-absolute text-white text-md-black top-43px right-30px" iconName="cross" text="Close" onClick={onClose} />
        <AnimalProfileModal
          type={selectedType as any}
          title={profileTitle}
          animalType={selectedType as any}
          petData={selectedPetData ? [selectedPetData] : undefined}
          petDocumentData={selectedPetDocuments}
          roleType="agent"
          activeState={1}
          keyIndex={selectedIdx}
          onRemove={() => {}}
          isModal
          maxHight={deviceType === "mobile"}
        >
          <Button className="modal_close_btn d-none d-md-block position-absolute top-43px right-30px" iconName="cross" text="Close" onClick={onClose} />
          {formTemplate && renderAnimalCards(selectedType, selectedIdx)}
           { selectedPetDocuments && selectedPetDocuments.length > 0 &&
              <div className="fs-16px fw-normal text-black">
                <strong>{isQldRegion() ? "10" : selectedType === "fish" ? "3" : "4"}. Supporting Documents</strong>
              </div>
            }
          {selectedPetDocuments?.map((document, i) => <SupportDocument key={i} item={document} />)}
        </AnimalProfileModal>
      </FormProvider>
    </Modal>
  );
};
export default ProfileModal;